import React, { useCallback, useEffect, useState } from "react";
import "./style.css";

import { Button, Spinner, useToast } from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { getNumberSuffix } from "../../Library/helpers";
import { saveVehicleModel, updateVehicleModel } from "../../APIs/index";
import { Breadcrumb, CounterInput, PopUpModal, TextInput, Title, Table } from "../../Components/Atoms";
import { SETTING_ROUTES } from "../../Library/constants";

const FIELD_TYPE = {
  TEXT: 1,
  LABEL: 2,
  COUNTER: 3,
  MULTIPLE: 4,
};

const AddModel = () => {
  const [addModelFormFields, setAddModelFormFields] = useState([]);
  const [showModal, setShowModal] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  const toast = useToast();

  const getFormFields = useCallback((formData = {}) => {
    const formFields = [
      {
        type: FIELD_TYPE.TEXT,
        label: "Model Name",
        name: "nm",
        placeholder: "Enter Model Name",
        defaultValue: formData.nm,
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Model Price",
        name: "base_price",
        placeholder: "Enter Model Price",
        defaultValue: formData.base_price,
        unit: "(₹)",
      },
      {
        type: FIELD_TYPE.MULTIPLE,
        name: "colors",
        label: "Colors",
        defaultValue: formData.colors ? formData.colors.map(({ nm }) => nm) : [ "" ],
      },
      {
        type: FIELD_TYPE.LABEL,
        label: "Motor Specification",
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Torque",
        group: "motor",
        name: "torque",
        placeholder: "Enter Torque",
        defaultValue: formData.motor ? formData.motor.torque : "",
        unit: "(Nm)",
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Rated Power",
        group: "motor",
        name: "ratedPower",
        placeholder: "Enter Rated Power",
        defaultValue: formData.motor ? formData.motor.ratedPower : "",
        unit: "(W)",
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Max Speed",
        group: "motor",
        name: "maxSpd",
        placeholder: "Enter Max Speed",
        defaultValue: formData.motor ? formData.motor.maxSpd : "",
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "RPM",
        group: "motor",
        name: "rpm",
        placeholder: "Enter RPM",
        defaultValue: formData.motor ? formData.motor.rpm : "",
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Rated Voltage",
        class: "rated-voltage",
        group: "motor",
        name: "ratedVoltage",
        placeholder: "Enter Rated Voltage",
        defaultValue: formData.motor ? formData.motor.ratedVoltage : "",
        unit: "(V)",
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "High Temp Threshold (°C)",
        group: "motor",
        name: "highTempThreshld",
        placeholder: "Enter High Temp Threshold",
        defaultValue: formData.motor ? formData.motor.highTempThreshld : "",
        unit: "(°C)",
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Low Temp Threshold (°C)",
        group: "motor",
        name: "lowTempThreshld",
        placeholder: "Enter Low Temp Threshold",
        defaultValue: formData.motor ? formData.motor.lowTempThreshld : "",
        unit: "(°C)",
      },
      {
        type: FIELD_TYPE.LABEL,
        label: "Battery Specification",
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Capacity",
        group: "battery",
        name: "cap",
        placeholder: "Enter Battery Capacity",
        defaultValue: formData.battery ? formData.battery.cap : "",
        unit: "(ah)",
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Operating Temprature",
        group: "battery",
        name: "operatingTemp",
        placeholder: "Enter Operating Temprature",
        defaultValue: formData.battery ? formData.battery.operatingTemp : "",
        unit: "(°C)",
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Charging Current",
        group: "battery",
        name: "chargeCurr",
        placeholder: "Enter Charging Current",
        defaultValue: formData.battery ? formData.battery.chargeCurr : "",
        unit: "(V)",
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Discharging Current",
        group: "battery",
        name: "dischargeCurr",
        placeholder: "Enter Disharging Current",
        defaultValue: formData.battery ? formData.battery.dischargeCurr : "",
        unit: "(V)",
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Charging Cycles",
        group: "battery",
        name: "chargingCycles",
        placeholder: "Enter Charging Cycles",
        defaultValue: formData.battery ? formData.battery.chargingCycles : "",
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "High Temp L1 Threshold",
        group: "battery",
        name: "highL1TempThreshld",
        placeholder: "Enter High Temp L1 Threshold",
        defaultValue: formData.battery ? formData.battery.highL1TempThreshld : "",
        unit: "(°C)",
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Low Temp L1 Threshold",
        group: "battery",
        name: "lowL1TempThreshld",
        placeholder: "Enter Low Temp L1 Threshold",
        defaultValue: formData.battery ? formData.battery.lowL1TempThreshld : "",
        unit: "(°C)",
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "High Temp L2 Threshold",
        group: "battery",
        name: "highL2TempThreshld",
        placeholder: "Enter High Temp L2 Threshold",
        defaultValue: formData.battery ? formData.battery.highL2TempThreshld : "",
        unit: "(°C)",
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Low Temp L2 Threshold",
        group: "battery",
        name: "lowL2TempThreshld",
        placeholder: "Enter Low Temp L2 Threshold",
        defaultValue: formData.battery ? formData.battery.lowL2TempThreshld : "",
        unit: "(°C)",
      },
      // {
      //   type: FIELD_TYPE.LABEL,
      //   label: "Free Service Details",
      // },
      // {
      //   type: FIELD_TYPE.MULTIPLE,
      //   label: "Service Details",
      //   name: "freeServiceDetails",
      //   defaultValue: formData.freeServiceDetails || [{ days: "", kms: "" }],
      //   isTable: true,
      // },
    ];

    return formFields;
  }, []);

  useEffect(() => {
    if (location.state && location.state.model) {
      setAddModelFormFields(getFormFields(location.state.model));
    } else setAddModelFormFields(getFormFields());

  }, [ location, getFormFields ]);

  const renderMultipleInputs = (formField, errIndex, isTable) => {
    if (!isTable) {
      const inputs = [];
      for (let i = 0; i < formField.defaultValue.length; i++) {
        inputs.push(
          <div className="add-modal-text-field-group color-field-group" key={i}>
            <TextInput
              inputName={`colors.${i + 1}`}
              label={`Color ${i + 1}`}
              className="add-modal-text-field color-text-field"
              labelClassName="add-modal-text-field-label"
              errMessage={errIndex - 1 === i ? `Please enter Color ${i + 1}` : ""}
              defaultValue={formField.defaultValue[i]}
              group={formField.group}
            />
          </div>
        );
      }
      return inputs;
    } else {
      let tableRows = [];
      for (let i = 0; i < formField.defaultValue.length; i++) {
        tableRows.push({
          cells: [
            `${i + 1}${getNumberSuffix(i + 1)}`,
            <TextInput
              inputName={`freeServiceDetails.days.${i + 1}`}
              className="service-text-field"
              labelClassName="add-modal-service-field-label"
              errMessage={(errIndex - 1 === i) ? " " : null}
              defaultValue={formField.defaultValue[i] ? formField.defaultValue[i].days : ""}
              group={formField.group}
            />,
            <TextInput
              inputName={`freeServiceDetails.kms.${i + 1}`}
              className="service-text-field"
              labelClassName="add-modal-service-field-label"
              errMessage={(errIndex - 1 === i) ? " " : null}
              defaultValue={formField.defaultValue[i] ? formField.defaultValue[i].kms : ""}
              group={formField.group}
            />,
          ],
        });
      }

      return (
        <Table
          headings={tableRows.length ? ["Service Count", "Days Count", "Kms Count"] : []}
          rows={tableRows}
        />
      );
    }
  };

  const saveModelDetails = (modelData) => {
    let postFunction = saveVehicleModel;
    if (location.state && location.state.model) {
      postFunction = updateVehicleModel;
      modelData = { ...modelData, modelId: location.state.model.idx };
    }

    postFunction(modelData, (failure, success) => {
      if(failure) {
        setShowModal({
          open: true,
          modalMsg: (() => {
            try {
              const parsedData = JSON.parse(failure);
              return parsedData.data || "Something went wrong!";
            } catch {
              return "Something went wrong!";
            }
          })(),
          confirmBtn: "Okay",
          onConfirm: () => setShowModal(null),
          onModalClose: () => setShowModal(null),
        });
      } else {
        setShowModal({
          open: true,
          modalMsg: "Model details have been saved successfully",
          confirmBtn: "Okay",
          onConfirm: () => navigate(SETTING_ROUTES.MODELS.path),
        });
      };
    })
  };

  const getFormData = (e) => {
    e.preventDefault();
    const formData = {};
    let isInvalid = false;
    let editForm = location.state && location.state.model;

    let errorInputIndex = addModelFormFields.findIndex((field) => field.errMessage);
    if (errorInputIndex !== -1) {
      delete addModelFormFields[errorInputIndex].errMessage;
      setAddModelFormFields(addModelFormFields);
    }

    for (const input of Array.from(e.target)) {
      const index = addModelFormFields.findIndex((field) => {
        if (field.type === FIELD_TYPE.MULTIPLE) {
          let nm = input.name.split(".")[0];
          return field.name === nm;
        } else {
          return field.name === input.name;
        }
      });

      const formField = addModelFormFields[index];
      if (!formField) continue;

      if (input.type === "text" && !input.value) isInvalid = true;
      if (formField.type === FIELD_TYPE.MULTIPLE && input.value === "0") isInvalid = true;

      if (isInvalid) {
        addModelFormFields[index] = {
          ...addModelFormFields[index],
          errMessage:
            Number(input.name.slice(-1)) ||
            `Please enter ${input.attributes.datalabel?.value}`.replace(/['"]+/g, ""),
        };
        setAddModelFormFields([...addModelFormFields]);

        if (isInvalid) {
          input.scrollIntoView({ behavior: "smooth", block: "center" });
          break;
        }
      }
      if (input.name) {
        if (input.attributes.datagroup) {
          // For Grouping Fields into an Object
          let key = input.attributes.datagroup.value;

          if (!editForm || String(formField.defaultValue) !== String(input.value)) {
            if (!formData[key]) formData[key] = {};
            formData[key][input.name] = input.value;
          }
        } else if (formField.type === FIELD_TYPE.MULTIPLE) {
          // For Adding Multiple Fields into an Array
          let splitName = input.name.split(".");

          if (splitName.length === 2) {
            let key = splitName[0];
            if (!formField.defaultValue.includes(input.value)) {
              if (!formData[key]) formData[key] = [];
              formData[key].push(input.value);
            }
          } else if (splitName.length > 2) {
            let [ key, nm, index ] = splitName;

            if (!formData[key]) formData[key] = [];
            if (!formData[key][index - 1]) formData[key][index - 1] = {};

            formData[key][index - 1][nm] = input.value;
          }

        } else {
          if (!editForm || formField.defaultValue !== input.value) {
            formData[input.name] = input.value;
          }
        }
      }
    }

    if (!isInvalid) {
      // Deleting freeServiceDetails if it hasn't changed
      if (location.state && location.state.model && formData.freeServiceDetails && formData.freeServiceDetails.every((row, i) => {
        const def = location.state.model.freeServiceDetails[i];
        return (row.days === def.days && row.kms === def.kms);
      })) {
        delete formData["freeServiceDetails"];
      }

      if (!Object.keys(formData).length) {
        return toast({ title: "Nothing to Update", variant: "subtle", position: "bottom-right" });
      }

      setShowModal({
        open: true,
        modalMsg: "Please ensure that all the details of model are up to date",
        closeBtn: "Cancel",
        confirmBtn: "Confirm",
        onModalClose: () => setShowModal(null),
        onConfirm: () => saveModelDetails(formData),
      });
    }
  };

  const handleCounterChange = (e, index) => {
    setAddModelFormFields((old) => {
      let newState = [ ...old ];
      let newField = { ...newState[index] };
      newState[index] = newField;
      newField.defaultValue.length = e;

      return newState;
    });
  };

  const title = (location.state && location.state.model) ? "Update Model" : "Add Model";

  const breadcrumbPaths = [
    { idx: 1, name: "Settings", link: SETTING_ROUTES.MODELS.path },
    { idx: 2, name: title, link: "", isCurrentPage: true },
  ];

  return (
    <section className="panel-main">
      <Breadcrumb paths={breadcrumbPaths} />

      <div className="add-model">
        <Title>{title}</Title>

        {addModelFormFields ? (
          <form className="add-model-form" onSubmit={getFormData}>
            {addModelFormFields.map((formField, idx) => (
              <React.Fragment  key={idx}>
                {formField.type === FIELD_TYPE.TEXT && (
                  <div key={idx} className={`add-modal-text-field-group ${formField.class || ""}`}>
                    <TextInput
                      inputName={formField.name || ""}
                      placeholder={formField.placeholder}
                      className="add-modal-text-field"
                      label={formField.label}
                      labelClassName="add-modal-text-field-label"
                      rightElement={formField.unit}
                      errMessage={formField.errMessage || ""}
                      defaultValue={formField.defaultValue}
                      group={formField.group}
                    />
                  </div>
                )}

                {formField.type === FIELD_TYPE.LABEL && (
                  <p key={idx} className="add-model-subheadings">{formField.label || ""}</p>
                )}

                {formField.type === FIELD_TYPE.MULTIPLE && (
                  <>
                    <div key={idx} className="add-modal-text-field-group counter-input-group">
                      {<CounterInput
                        inputName={formField.name}
                        labelClassName="add-modal-text-field-label"
                        label={formField.label}
                        counterContainer="counter-input"
                        counterButton="counter-button"
                        counterDisplay="counter-display"
                        errMessage={formField.errMessage || ""}
                        defaultValue={formField.defaultValue.length}
                        onChange={(e) => handleCounterChange(e, idx)}
                        group={formField.group}
                        minValue={1} maxValue={10}
                      />}
                    </div>
                    <div key={idx + "value"} className="colorInputFields">
                      {renderMultipleInputs(formField, formField.errMessage, formField.isTable)}
                    </div>
                  </>
                )}
              </React.Fragment>
            ))}

            <div className="submit-button">
              <Button type="submit" className="add-model-button">
                {title}
              </Button>
            </div>
          </form>
        ) : (
          <div className="add-model-loader">
            <Spinner />
          </div>
        )}
      </div>

      <PopUpModal {...showModal} />
    </section>
  );
};

export default AddModel;
